var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-row',{attrs:{"gutter":10}},[_c('a-col',{attrs:{"span":6}},[_c('tooCategory',{on:{"change":_vm.change}})],1),_c('a-col',{attrs:{"span":18}},[_c('toolList',{ref:"list"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }